import { Image, View } from 'react-native'
import { styled } from '~/core/styled'

export const ImgContainer = styled(View, theme => {
  return {
    base: {
      minWidth: theme.sizingColossal,
      height: theme.sizingColossal,
      borderColor: theme.colorNone,
      borderRadius: theme.borderRadiusTinycontainer,
    },
  }
})
export const Img = styled(Image, theme => {
  return {
    base: {
      width: 'auto',
      height: '100%',
      borderRadius: theme.borderRadiusTinycontainer,
    },
  }
})
